import Store from "../content/Store";
import Content from "../content/Content";
import React from "react";

export function getPhone(state) {
  return getPhoneImpl(state, "TelephonePolicyServicing");
}

export function getPhoneClaims(state) {
  return getPhoneImpl(state, "TelephoneClaims");
}

export function getPhoneTechnical(state) {
  return getPhoneImpl(state, "TelephoneTechnicalSupport");
}

function getPhoneImpl(state, type) {
  let phoneNumbers =
    state &&
    state.CurrentPolicy &&
    state.CurrentPolicy.PolicyServicingTelephones &&
    state.CurrentPolicy.PolicyServicingTelephones[type];

  if (!phoneNumbers) {
    phoneNumbers = <Content name={Store.GeneralPages.PhoneNumbers} />;
  }
  return phoneNumbers;
}

export function getOpeningHours(state) {
  return getOpeningHoursImpl(state, "OpeningHoursPolicyServicing");
}

export function getOpeningHoursClaims(state) {
  return getOpeningHoursImpl(state, "OpeningHoursClaims");
}

export function getOpeningHoursTechnical(state) {
  return getOpeningHoursImpl(state, "OpeningHoursTechnicalSupport");
}

function getOpeningHoursImpl(state, type) {
  let openingHours =
    state &&
    state.CurrentPolicy &&
    state.CurrentPolicy.PolicyServicingTelephones &&
    state.CurrentPolicy.PolicyServicingTelephones[type];

  if (!openingHours) {
    if (
      type === "OpeningHoursPolicyServicing" &&
      state.CurrentPolicy &&
      state.CurrentPolicy.IsLocationCorporateHub
    ) {
      openingHours = (
        <Content
          name={Store.GeneralPages.OpeningHoursForLocationCorporateHub}
        />
      );
    } else if (type === "OpeningHoursTechnicalSupport") {
      openingHours = (
        <Content name={Store.GeneralPages.OpeningHoursForTechnicalHelpline} />
      );
    } else {
      openingHours = <Content name={Store.GeneralPages.OpeningHours} />;
    }
  }

  return openingHours;
}
